function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 13L1 17",
  stroke: "#00BB77",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 7C17 8.5913 16.3679 10.1174 15.2426 11.2426C14.1174 12.3679 12.5913 13 11 13C9.4087 13 7.88258 12.3679 6.75736 11.2426C5.63214 10.1174 5 8.5913 5 7C5 5.4087 5.63214 3.88258 6.75736 2.75736C7.88258 1.63214 9.4087 1 11 1C12.5913 1 14.1174 1.63214 15.2426 2.75736C16.3679 3.88258 17 5.4087 17 7V7Z",
  stroke: "#00BB77",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgLoupeIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoupeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loupe-icon.5d80a6c7.svg";
export { ForwardRef as ReactComponent };